import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { setDarkMode, setLanguage } from "../redux/user/user.action";
import { useDispatch, useSelector } from "react-redux";
import { languageOptions } from "../common/Config";



function AuthLayout() {

    const hasResetRef = useRef(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { lang } = useParams();
    const user = useSelector((state) => state.user);
    const location = useLocation()
    const isDark = user.isDarkMode;
    const [isDarkMode, setIsDarkMode] = useState(() => {
        return isDark;
    });

    let selectedLand = languageOptions.filter((e) => e.label == user?.language)
    const [selectedLanguage, setSelectedLanguage] = useState(selectedLand && selectedLand.length > 0 ? selectedLand[0] : languageOptions[0]);

    useEffect(() => {
        const addTranslateScript = () => {
            const googleTranslateElementInit = () => {
                new window.google.translate.TranslateElement(
                    {
                        pageLanguage: "en",
                        autoDisplay: false,
                    },
                    "google_translate_element"
                );
            };

            if (!window.google?.translate) {
                var addScript = document.createElement("script");
                addScript.setAttribute(
                    "src",
                    "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
                );
                document.body.appendChild(addScript);
                window.googleTranslateElementInit = googleTranslateElementInit;
            }
        };
        addTranslateScript();




        const syncDropdown = setInterval(() => {
            const googleSelect = document.querySelector(".goog-te-combo");

            if (!googleSelect) return;

            if (!googleSelect.value && !hasResetRef.current) {
                hasResetRef.current = true;

                // Reset select dropdown
                const select = document.querySelector(".goog-te-combo");
                if (select) {
                    select.value = "en";
                    select.dispatchEvent(new Event("change"));
                }

                dispatch(setLanguage("English"));
                setSelectedLanguage(languageOptions[0]);

                // 🔁 Update the URL from "/othr" to "/en"
                const pathParts = location.pathname.split("/");

                if (pathParts[1] && (pathParts[1] === "othr" || pathParts[1] === "en")) {
                    pathParts[1] = "en";
                    const newPath = pathParts.join("/") + location.search + location.hash;
                    // window.location.href = newPath
                    navigate(newPath, { replace: true });
                }
            }

            if (googleSelect.value && googleSelect.value !== "en") {
                hasResetRef.current = false;
            }
        }, 1000);


        return () => {
            clearInterval(syncDropdown);
        };

    }, []);

    useEffect(() => {
        const select = document.querySelector('.goog-te-combo');
        // console.log(select.value);

        if (select && selectedLanguage.value != "en") {
            // console.log('comes', select.value);
            let lng = lang ? (lang == 'othr' ? 'othr' : lang) : selectedLanguage.value;

            select.value = lng == 'pt' ? 'pt-PT' : lng; // target language (English)
            select.dispatchEvent(new Event('change'));
        }
    }, [selectedLanguage.value, document.querySelector('.goog-te-combo')])

    useEffect(() => {
        if (isDarkMode) {
            document.body.classList.add("dark");
        } else {
            document.body.classList.remove("dark");
        }
        dispatch(setDarkMode(isDarkMode))
    }, [isDarkMode]);

    return (
        <>
            <div id="google_translate_element" style={{ display: 'none' }}></div>
            <Outlet />
        </>
    );
}

export default AuthLayout;